export default __webpack_public_path__ + "static/media/Android_VOC.67e68be8.png";